import React, { Component } from 'react';
import '../../../../styles/components/auth.scss';
import { Loader2, Smartphone } from 'lucide-react';
import ReCAPTCHA from 'react-google-recaptcha';
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { withRouter } from '../../../../hoc/withRouter';
import { Link } from 'react-router-dom';
import { baseUrl } from '../../../../constants/global';
import { requestOtpLogin } from './services/authService';
import { toast } from 'react-toastify';
import i18n from '../../../../i18n';

class LoginWithOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: null,
      captchaValue: null,
      isSubmitting: false,
      errors: {},
    };
    this.recaptchaRef = React.createRef();
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  handlePhoneChange = (value) => {
    this.setState({ phoneNumber: value });
  };

  handleCaptchaChange = (value) => {
    this.setState({ captchaValue: value });
  };

  validateForm = () => {
    const errors = {};
    const { phoneNumber, captchaValue } = this.state;

    if (!phoneNumber) errors.phoneNumber = 'mobile number is required';
    if (!captchaValue) errors.captchaValue = 'captcha is required';

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  };

  renderFieldError = (fieldName) => {
    if (this.state.errors[fieldName]) {
      return <div className="field-error">{this.state.errors[fieldName]}</div>;
    }
    return null;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.validateForm()) {
      return;
    }
    const { phoneNumber, captchaValue } = this.state;
    const phone = parsePhoneNumber(phoneNumber);
    const countryCodeWithPlus = phone ? `+${phone.countryCallingCode}` : '';

    this.setState({ isSubmitting: true });

    try {
      const result = await requestOtpLogin({
        country_code: countryCodeWithPlus,
        mobile: phone?.nationalNumber,
        captcha_token: captchaValue,
      });

      const { response } = result;

      // Check if verification is required (OTP/email)
      if (response?.data?.requires_verification) {
        this.props.navigate(`/login/otp-verify-email/${response.data.verification_token}`, {
          state: {
            data: response.data.email,
            type: 'email',
          },
        });
        return;
      }

      this.props.navigate(`/login/otp-verify-mobile`, {
        state: {
          data: phone?.nationalNumber,
          countryCode: countryCodeWithPlus,
          type: 'mobile',
        },
      });
      return;
    } catch (error) {
      toast.error(error.message || 'Login failed. Please try again.');
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handleLogin = () => {
    this.props.navigate(`/login`);
  };

  handleRegisterBidder = () => {
    this.props.navigate(`/register`);
  };

  handleRegisterClient = () => {
    this.props.navigate(`/client-registration`);
  };

  render() {
    const { phoneNumber, errors, isSubmitting } = this.state;

    return (
      <div className="register-container">
        <div className="login-left-section">
          <div className="auth-content">
            <div className="accent-line"></div>
            <h1 className="title">
              {i18n.t('login_banner_title')}{' '}
              <span className="highlight-l2">{i18n.t('login_banner_title_b')}</span>,{' '}
              {i18n.t('login_banner_title_c')}.
            </h1>
            <p className="subtitle-l2">{i18n.t('login_banner_subtitle')}</p>
          </div>
        </div>

        <div className="login-right-section">
          <div className="login-card">
            <h3 className="welcome-title">{i18n.t('login_with_otp')}</h3>
            <p className="welcome-subtitle">{i18n.t('login_otp_card_subtitle')}</p>

            <form onSubmit={this.handleSubmit}>
              <div className="form-group-l2 left-right">
                <label htmlFor="phoneNumber">{i18n.t('mobile_number')}</label>
                <div className="input-wrapper">
                  <PhoneInput
                    international
                    defaultCountry="OM"
                    value={phoneNumber}
                    onChange={this.handlePhoneChange}
                    placeholder="Enter phone number"
                    className={`custom-phone-input ${errors?.phoneNumber ? 'error' : ''}`}
                    dir="ltr"
                  />
                </div>
                {this.renderFieldError('phoneNumber')}
              </div>

              <div className="form-group-l2">
                <div className="recaptcha-wrapper">
                  <ReCAPTCHA
                    sitekey="6LceESUpAAAAAAC7C5FaMVWVBIdBRwWzMqR8Wvq7"
                    onChange={this.handleCaptchaChange}
                    size="normal"
                    style={{
                      transform: 'scale(0.85)',
                      transformOrigin: '0 0',
                    }}
                  />
                  {this.renderFieldError('captchaValue')}
                </div>
              </div>

              <div className="form-links">
                <Link to="/forgot-password" className="link link-with-arrow">
                  {i18n.t('forget_password')}
                </Link>
                <a
                  href={`${baseUrl}/guide/login.pdf`}
                  target="_new"
                  className="link link-with-arrow"
                >
                  {i18n.t('user_guide')}
                  <svg
                    className="arrow-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M7 17L17 7M17 7H7M17 7v10" />
                  </svg>
                </a>
              </div>

              <div className="auth-action-buttons">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="button1 button1-gradient full-width"
                >
                  {i18n.t('send_otp')}
                  {isSubmitting ? (
                    <Loader2 className="animate-spin" size={18} />
                  ) : (
                    <Smartphone strokeWidth={1.5} />
                  )}
                </button>
                <button
                  type="button"
                  className="button1 button1-secondary full-width"
                  onClick={this.handleLogin}
                >
                  {i18n.t('login_with_username')}
                </button>
              </div>

              <div className="register-section">
                <p className="register-text">{i18n.t('dont_have_an_account')}</p>
                <div className="register-buttons">
                  <button
                    type="button"
                    onClick={this.handleRegisterBidder}
                    className="button1 button1-outline"
                  >
                    {i18n.t('register_bidder')}
                  </button>
                  <button
                    type="button"
                    onClick={this.handleRegisterClient}
                    className="button1 button1-outline"
                  >
                    {i18n.t('register_client')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LoginWithOtp);
